import styled from '@emotion/styled';

const StyledP = styled.p({}, ({ theme }) => ({
  color: theme.palette.colors.white,
  fontSize: theme.typography.fontSize.large
}));

export default StyledP;
